var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapPointerGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 53,
    viewBox: "0 0 44 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 52543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 52510",
    filter: "url(#filter0_d_891_1675)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6666 1.54103C32.0939 2.55412 34.2972 4.03665 36.15 5.90353C39.8957 9.64927 42 14.7295 42 20.0268C42 25.324 39.8957 30.4042 36.15 34.15L22.0268 47.9636L7.91958 34.166C6.05061 32.3152 4.56558 30.1136 3.54974 27.6874C2.53391 25.2613 2.00727 22.6583 2.00007 20.0281C1.99288 17.3979 2.50525 14.7921 3.50779 12.3604C4.51033 9.92873 5.98328 7.719 7.8421 5.85808C9.70091 3.99716 11.909 2.5217 14.3395 1.51642C16.7701 0.511127 19.3753 -0.00419769 22.0055 2.57515e-05C24.6358 0.0042492 27.2393 0.527937 29.6666 1.54103Z",
    fill: "#A4AAB4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.1154 17.8182H23.8774L24.8523 11.0549C24.9916 10.0887 23.8426 9.60558 23.3204 10.3488L16.1481 20.6424C15.7303 21.237 16.1481 22.1288 16.8445 22.1288H20.0824L19.0727 28.8921C18.9335 29.8583 20.0824 30.3414 20.6047 29.5982L27.7769 19.3046C28.2295 18.6729 27.8117 17.8182 27.1154 17.8182Z",
    fill: "#6B6D72"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_891_1675",
    x: 0,
    y: 0,
    width: 44,
    height: 52.9636,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_891_1675"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_891_1675",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPointerGray);
export default __webpack_public_path__ + "static/media/map_pointer_gray.7f206874e1298aaa16ed761fcafa66b3.svg";
export { ForwardRef as ReactComponent };